var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.9166 29.0334V30.7501H27.6333L33.3833 25.0001L31.6666 23.2834L25.9166 29.0334Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.66675H26.6666V19.8334L30 16.5001V6.66675Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 6.66675H6.66663V33.3334H9.99996V6.66675Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.66675H16.6666V13.3334H20V6.66675Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.6667H16.6666V23.3334H20V16.6667Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6667H16.6666V33.3334H20V26.6667Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5999 20.9835L35.6833 19.0668C34.6999 18.0835 33.1166 18.0835 32.1499 19.0668L23.3333 27.8835V33.3335H28.7833L37.5999 24.5168C38.5833 23.5335 38.5833 21.9502 37.5999 20.9835ZM27.6333 30.7502H25.9166V29.0335L31.6666 23.2835L33.3833 25.0002L27.6333 30.7502Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.9166,
    y1: 23.2834,
    x2: 34.4522,
    y2: 29.2109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 26.6666,
    y1: 6.66675,
    x2: 32.1454,
    y2: 7.62997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 6.66663,
    y1: 6.66675,
    x2: 12.2725,
    y2: 7.15337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 16.6666,
    y1: 6.66675,
    x2: 21.7071,
    y2: 8.41691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 16.6666,
    y1: 16.6667,
    x2: 21.7071,
    y2: 18.4169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 16.6666,
    y1: 26.6667,
    x2: 21.7071,
    y2: 28.4169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 23.3333,
    y1: 18.3293,
    x2: 40.4853,
    y2: 30.2405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRoad);
export default __webpack_public_path__ + "static/media/edit_road.72cd541e8e76b6cece83da7440fe15ca.svg";
export { ForwardRef as ReactComponent };